import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import TimelineQueryCard from "../../charts/TimelineQueryCard";
import { offersSubscriptionsQuery } from "../offerAnalytics.queries";
import { buildSubscriptionTimeline } from "../offerAnalytics.utils";

import type { JSX } from "react";

import type { GetOffersSubscriptionsResponse } from "@/src/api/StatsAPI.types";

import type { ChartSeries, TimelineDatum } from "../../charts/charts.types";
import type {
  OfferAnalyticsFilterProps,
  SubscriptionSeriesKey,
} from "../offerAnalytics.types";

function buildTimeline(
  response: GetOffersSubscriptionsResponse | undefined,
): TimelineDatum<SubscriptionSeriesKey>[] {
  return buildSubscriptionTimeline(response?.data ?? []);
}

function SubscriptionsTimelineCard({
  filters,
}: OfferAnalyticsFilterProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");

  const seriesList = useMemo(
    (): ChartSeries<SubscriptionSeriesKey>[] => [
      {
        key: "new",
        label: t("offerAnalytics.series.new"),
        color: "var(--chart-1)",
      },
      {
        key: "gift",
        label: t("offerAnalytics.series.gift"),
        color: "var(--chart-2)",
      },
      {
        key: "freecopy",
        label: t("offerAnalytics.series.freecopy"),
        color: "var(--chart-3)",
      },
    ],
    [t],
  );

  return (
    <TimelineQueryCard
      buildTimeline={buildTimeline}
      endDate={filters.endDate}
      query={offersSubscriptionsQuery(projectSlug, filters)}
      seriesList={seriesList}
      startDate={filters.startDate}
      title={t("offerAnalytics.charts.subscriptionsTimeline")}
    />
  );
}

export default SubscriptionsTimelineCard;
